<div
  class="flex flex-col gap-6"
  *transloco="
    let t;
    prefix: 'shared.request-walkthrough-modal.request-walkthrough-success'
  "
>
  <div class="flex flex-row justify-between">
    <h2 class="text-black text-[1.75rem]">
      {{ t("header") }}
    </h2>
    <button class="p-2">
      <i class="icon-close text-black text-xl" (click)="closeDialog()"></i>
    </button>
  </div>
  <div class="divider-line1"></div>
  <p>{{ t("infoText.walkthroughConfirmed") }}</p>
  <div class="flex flex-col items-center">
    <img
      class="h-auto w-full max-w-[407px] mt-10"
      src="../../../../../assets/img/request-walkthrough/success.png"
      alt=""
    />
  </div>
</div>
